import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyBJjOvZy06WZ3FItAJ9pyLbvevd4BHLRTg",
  authDomain: "apollo-a41ae.firebaseapp.com",
  databaseURL: "https://apollo-a41ae.firebaseio.com",
  projectId: "apollo-a41ae",
  storageBucket: "apollo-a41ae.appspot.com",
  messagingSenderId: "826222173046",
  appId: "1:826222173046:web:8bf6eb48ee7810800b7857",
  measurementId: "G-TTZK48XR4T",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();
const auth = firebase.auth();

export { db, auth };
